// components/results/RestrictionFlags.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Card, ListGroup, Badge, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faExclamationTriangle, faExclamationCircle, faCheckCircle as faLowSeverity } from '@fortawesome/free-solid-svg-icons'; // faLowSeverity for clarity

const RestrictionFlags = ({ flags = [] }) => {
    if (!flags || flags.length === 0) {
        return (
            <Alert variant="success" className="shadow-sm small py-2 px-3">
                <FontAwesomeIcon icon={faLowSeverity} className="me-2" />
                No specific restriction conflicts found with this product based on your profile.
            </Alert>
        );
    }

    const getSeverityStyle = (severity) => {
        switch (severity?.toLowerCase()) {
            case 'high':
                return { variant: 'danger', icon: faBan, text: "High Concern" };
            case 'medium':
                return { variant: 'warning', icon: faExclamationTriangle, text: "Medium Concern" };
            case 'low':
                return { variant: 'info', icon: faExclamationCircle, text: "Low Concern" };
            default:
                return { variant: 'secondary', icon: faExclamationCircle, text: "Notice" };
        }
    };

    return (
        <Card className="shadow-sm mb-4 border-danger-subtle"> {/* Subtle border for emphasis */}
            <Card.Header as="h5" className="bg-light text-danger border-bottom fw-bold p-3">
                <FontAwesomeIcon icon={faBan} className="me-2" /> Restriction Flags
            </Card.Header>
            <ListGroup variant="flush">
                {flags.map((flag, index) => {
                    const style = getSeverityStyle(flag.severity);
                    return (
                        <ListGroup.Item key={index} className={`p-3 restriction-flag-item restriction-flag-${flag.severity?.toLowerCase() || 'notice'}`}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="fw-bold text-danger-emphasis">{flag.restrictedItem || "Restricted Item"}</span>
                                <Badge pill bg={style.variant} className="px-2 py-1">
                                    <FontAwesomeIcon icon={style.icon} className="me-1" />
                                    {style.text}
                                </Badge>
                            </div>
                            {flag.reason && (
                                <p className="mb-0 small text-muted">
                                    <span className='fw-bold'>Reason: </span> {flag.reason}
                                </p>
                            )}
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        </Card>
    );
};

RestrictionFlags.propTypes = {
    flags: PropTypes.arrayOf(PropTypes.shape({
        restrictedItem: PropTypes.string,
        reason: PropTypes.string,
        severity: PropTypes.oneOf(['high', 'medium', 'low', 'High', 'Medium', 'Low'])
    }))
};

export default RestrictionFlags;